import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

const accrualCalculatorHistoryReducer = (state = InitialState.accrualCalculatorHistory, action) => {
  switch (action.type) {
    case types.LOAD_ACCRUAL_CALCULATOR_HISTORY:
      return action.history;
    default:
      return state;
  }
};

export default accrualCalculatorHistoryReducer;
